import type { DurationLikeObject } from 'luxon';
import { Duration as LuxonDuration } from 'luxon';

import type { IToHumanDurationOptions } from './toHumanDuration';
import { toHumanDuration } from './toHumanDuration';

export type IDurationProps = {
  ms: number;
  human?: boolean | IToHumanDurationOptions;
};

const getMinDuration = (minUnit: keyof DurationLikeObject): LuxonDuration => {
  return LuxonDuration.fromObject({ [minUnit]: 1 });
};

export const Duration: React.FC<IDurationProps> = (props) => {
  const { ms, human } = props;
  const duration = LuxonDuration.fromObject({ milliseconds: ms });

  const renderDuration = (): string => {
    if (!human) {
      return duration.toFormat('hh:mm:ss');
    }

    const minDuration =
      typeof human !== 'boolean' && human?.minUnit
        ? getMinDuration(human.minUnit)
        : undefined;
    if (minDuration !== undefined && ms < minDuration.as('milliseconds')) {
      const minHumanDuration = toHumanDuration(
        minDuration,
        typeof human === 'boolean' ? undefined : human,
      );
      return `< ${minHumanDuration}`;
    }

    return toHumanDuration(
      duration,
      typeof human === 'boolean' ? undefined : human,
    );
  };

  return renderDuration();
};
